import type { ApiResponse, Pagination } from '@/shared/types/api';
import { api } from '../../../shared/api';

export interface FeaturedHouse {
  id: string;
  name: string;
  images: string[];
  availableCapacity: string;
  price: string;
}

export interface FeaturedHousesData {
  houses: FeaturedHouse[];
  pagination: Pagination;
}

export interface FeaturedHousesFilters {
  page?: number;
  limit?: number;
  priceRange?: string;
}

export interface HouseDetails {
  id: string;
  name: string;
  address: string;
  city: string;
  state: string;
  zipCode: string;
  description: string;
  capacity: number;
  type: string;
  bedrooms: number;
  bathrooms: number;
  area: string;
  size: string;
  builtYear: number;
  isParkingAvailable: boolean;
  isFurnished: boolean;
  price: number;
  currency: string;
  seats: number;
  status: string;
  amenities: string[];
  images: string[];
  isActive: boolean;
  listingDate: string;
  createdAt: string;
  updatedAt: string;
}

export const residentOnboardingApis = {
  getFeaturedHouses: async (
    filters: FeaturedHousesFilters,
  ): Promise<FeaturedHousesData> => {
    const params = new URLSearchParams();

    if (filters.page) params.append('page', filters.page.toString());
    if (filters.limit) params.append('limit', filters.limit.toString());
    if (filters.priceRange) params.append('priceRange', filters.priceRange);

    const res = await api.get<ApiResponse<FeaturedHousesData>>(
      `/residents/dashboard/houses/featured?${params.toString()}`,
    );

    return res.data;
  },

  getHouseById: async (houseId: string): Promise<HouseDetails> => {
    const res = await api.get<ApiResponse<{ house: HouseDetails }>>(
      `/residents/dashboard/houses/${houseId}`,
    );
    return res.data.house;
  },
};
